module.exports = __webpack_public_path__ + "img/risotto-alla-milanese.d7cd912d.png";